import React from 'react';
import {URL_SERVICIO} from 'constants/general';

export function HeaderTiendasMenu() {

    return (
        <nav className="menuTiendas">
            <ul className="ulMenuTiendas">
                <li className="tiendas alone">
                    <a href={`/localizador-tiendas/`} >Localiza tu tienda</a>
                </li>
                <li className="mall alone">
                    <a href={URL_SERVICIO} rel="noopener noreferrer" >Servicios</a>
                    {/* <span>Servicios</span>
                    <div className="contentServicios">
                        <ul className="ulServicios">
                            <li className="liServicios"><Link to="/auto-center/">Autocenter</Link></li>
                            <li className="liServicios"><a href={BASE_PORTAL +"/c/servicio-tecnico/index_36.html"} target="_blank" rel="noopener noreferrer">Servicio Técnico</a></li>
                            <li className="liServicios"><a href={"https://serviciosgfi.inbursa.com:4070/multiplataforma/mvc/others/autotalPublico/init?ca=PUBLICO&pa=P&pro=SEARS#no-back-button"} target="_blank" rel="noopener noreferrer">Autotal Inbursa</a></li>
                            <li className="liServicios"><a href="https://www.viajesears.com/" target="_blank" rel="noopener noreferrer">Viajes Sears</a></li>
                            <li className="liServicios"><Link to="/dudas-comentarios/">Contáctanos</Link></li>
                        </ul>
                    </div> */}
                </li>
            </ul>
        </nav>
    )
}